import React from "react";
import AuthHeader from "../layout/AuthHeader";
import Button from "../Button";

const CountryNotAvailable = ({country, setCountry}) => {

  const errorMain = {
    it: "Servizio momentaneamente non disponibile",
    es: "Servicio temporalmente no disponible"
  }

  const errorDesc = {
    it: "Torneremo presto online",
    es: "Volveremos a estar en línea pronto"
  }

  return (
    <div className="min-h-full pt-4 pb-12 flex flex-col bg-white fixed inset-0">
      <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex-shrink-0 flex justify-center">
          <AuthHeader />
        </div>
        <div className="py-16">
          <div className="text-center">
            <h1 className="mt-2 text-2xl text-black-500 tracking-tight sm:text-3xl">
              {errorMain[country.code]}
            </h1>
            <p className="mt-2 text-base text-gray-500">
              {errorDesc[country.code]}
            </p>
            <div className="mt-6">
              <Button
                onClick={() => setCountry(undefined)}
                styleType="empty"
                className="text-xs text-black-500 hover:text-am-500 mt-10"
              >
                Change country <span aria-hidden="true" className="ml-2"> &rarr;</span>
              </Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CountryNotAvailable;
